<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <h1>Some app info</h1>
    <p><em>Some app info</em> can quickly generate and host your marketing, contact, and privacy policy pages.</p>
    <p>Here's an example <a href="app/KdvXMA0QJQUOutDrK7Q0CTJPems2" target="_blank">app info page</a> for this site.</p>
  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return { }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
img {
  height: 200px;
}
</style>